import { useState, useEffect } from "react";
import CustomCheckbox from "../../../../../../components/CustomCheckbox";
import "../../../../../../styles/selectBar.css";

const VocabularySelectionPage = ({
  worksheet,
  selectedTypes,
  setSelectedTypes,
}) => {
  // 복습 활성화/비활성화 및 최대 복습 회수 상태 추가
  const [isRetryEnabled, setIsRetryEnabled] = useState(() => {
    const found = selectedTypes.find((type) => type.key === "exam");
    return found ? found.isRetryEnabled !== false : true;
  });
  const [isAutoRetryEnabled, setIsAutoRetryEnabled] = useState(() => {
    return false;
  });
  const [maxRetries, setMaxRetries] = useState(() => {
    const found = selectedTypes.find((type) => type.key === "exam");
    if (found && typeof found.maxRetries === "number") return found.maxRetries;
    // Try to load from cookie (native)
    const cookieValue = (() => {
      const match = document.cookie.match(/(?:^|; )maxRetries=([^;]*)/);
      return match ? decodeURIComponent(match[1]) : undefined;
    })();
    if (cookieValue !== undefined) return Number(cookieValue);
    return 3;
  });

  const examData =
    setSelectedTypes === undefined
      ? []
      : worksheet.data.find((paragraph) => paragraph.title.includes("테스트"))
          .data;

  const maxExamCount = setSelectedTypes === undefined ? 99 : examData.length;

  const setExamCount = (count) => {
    setSelectedTypes([
      {
        key: "exam",
        count,
        isRetryEnabled,
        isAutoRetryEnabled: isAutoRetryEnabled,
        maxRetries: isRetryEnabled ? maxRetries : 0,
      },
    ]);
  };

  // 복습 활성화/비활성화 토글 핸들러
  const handleRetryToggle = (e) => {
    const enabled = e.target.checked;
    setIsRetryEnabled(enabled);
    setSelectedTypes([
      {
        key: "exam",
        count: examCount,
        isRetryEnabled: enabled,
        isAutoRetryEnabled: enabled ? isAutoRetryEnabled : false,
        maxRetries: enabled ? maxRetries : 0,
      },
    ]);
  };

  const handleAutoRetryToggle = (e) => {
    const enabled = e.target.checked;
    setIsAutoRetryEnabled(enabled);
    setSelectedTypes([
      {
        key: "exam",
        count: examCount,
        isRetryEnabled: isRetryEnabled,
        isAutoRetryEnabled: enabled,
        maxRetries: (isRetryEnabled ? maxRetries : 0),
      },
    ]);
  };

  // 최대 복습 회수 변경 핸들러
  const handleMaxRetriesChange = (e) => {
    const value = Number(e.target.value);
    setMaxRetries(value);
    // Set cookie for 1 year (native)
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `maxRetries=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    setSelectedTypes([
      {
        key: "exam",
        count: examCount,
        isRetryEnabled,
        isAutoRetryEnabled: isAutoRetryEnabled,
        maxRetries: isRetryEnabled ? value : 0,
      },
    ]);
  };

  useEffect(() => {
    if (setSelectedTypes !== undefined) {
      setExamCount(maxExamCount);
    }
    // eslint-disable-next-line
  }, [maxExamCount]);

  const examCount =
    selectedTypes.find((type) => type.key === "exam")?.count || 0;

  const examTypeList = [
    { type: "ant", text: "[반의어 -> 영단어 적기] 주관식" },
    { type: "syn", text: "[동의어 -> 영단어 적기] 주관식" },
    { type: "engeng", text: "[영어 뜻풀이 -> 영단어 적기] 주관식" },
    { type: "engkor", text: "[영단어 -> 한국어 뜻 적기] 주관식" },
    { type: "koreng", text: "[한국어 뜻 -> 영단어 적기] 주관식" },
    { type: "example_blank", text: "[한국어 뜻 -> 빈칸 채우기] 주관식" },
    { type: "ant_choice", text: "[반의어 -> 영단어 적기] 객관식" },
    { type: "syn_choice", text: "[동의어 -> 영단어 적기] 객관식" },
    { type: "engeng_choice", text: "[영어 뜻풀이 -> 영단어 적기] 객관식" },
    { type: "engkor_choice", text: "[영단어 -> 한국어 뜻 적기] 객관식" },
    { type: "koreng_choice", text: "[한국어 뜻 -> 영단어 적기] 객관식" },
    { type: "example_blank_choice", text: "[한국어 뜻 -> 빈칸 채우기] 객관식" },
  ];

  if (examData.length > 0) {
    for (let typeData of examTypeList) {
      typeData.count = examData[0].data.filter(
        (item) => item.type === typeData.type
      ).length;
    }
  }

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ fontSize: "18px", paddingBottom: "12px" }}>
        테스트 세트 설정
      </div>
      <div style={{ fontSize: "16px", paddingBottom: "20px", display: "flex", flexDirection: "row" }}>
        <select
          style={{ width: "120px", marginTop: "4px", fontSize: "16px" }}
          id="typeSelect"
          value={examCount}
          onChange={(e) => setExamCount(Number(e.target.value))}
          disabled={setSelectedTypes === undefined}
          className="customSelect"
        >
          {[...Array(maxExamCount)].map((_, index) => (
            <option key={index + 1} value={index + 1}>
              {index + 1}개 세트
            </option>
          ))}
        </select>
      </div>
      {/* 복습 활성화/비활성화 및 최대 복습 회수 UI */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "8px" }}>
        <label style={{ fontSize: "16px", display: "flex", alignItems: "center" }}>
          <CustomCheckbox
            checked={isRetryEnabled}
            onChange={handleRetryToggle}
            style={{ marginRight: "8px" }}
          />
          <span style={{ marginLeft: "8px" }}>복습 활성화</span>
        </label>
      </div>
      {(isRetryEnabled) && (
      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "8px" }}>
        <label style={{ fontSize: "16px", display: "flex", alignItems: "center" }}>
          <CustomCheckbox
            checked={isAutoRetryEnabled}
            onChange={handleAutoRetryToggle}
            style={{ marginRight: "8px" }}
          />
          <span style={{ marginLeft: "8px" }}>자동 복습 활성화</span>
        </label>
      </div>
      )}
      <div style={{ marginBottom: "16px" }}>
        <label style={{ fontSize: "16px", opacity: isRetryEnabled ? 1 : 0.5 }}>
          최대 복습 회수:<br />
          <select
            value={isRetryEnabled ? maxRetries : 0}
            onChange={handleMaxRetriesChange}
            disabled={!isRetryEnabled}
            className="customSelect"
            style={{ width: "120px", marginTop: "4px", fontSize: "16px" }}
          >
            <option value={-1}>제한 없음</option>
            {[...Array(10)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}회</option>
            ))}
          </select>
        </label>
      </div>
      {setSelectedTypes !== undefined && (
        <>
          <div style={{ fontSize: "16px", paddingBottom: "10px", fontWeight: "bold" }}>
            유형별 문제 수
          </div>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
            maxHeight: "calc(100% - 50px)",
            overflowY: "auto",
          }}>
            {examTypeList.map((typeData) => (
              <div key={typeData.type}>
                {typeData.text} - {typeData.count}개
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default VocabularySelectionPage;
